export class Resource {
  public id: number;
  public url: string;

  constructor(id: number, url: string) {
    this.id = id;
    this.url = url;
  }
}
